import { render } from "./ListItemMembro.vue?vue&type=template&id=070583a7&scoped=true"
import script from "./ListItemMembro.vue?vue&type=script&lang=js"
export * from "./ListItemMembro.vue?vue&type=script&lang=js"

import "./ListItemMembro.vue?vue&type=style&index=0&id=070583a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070583a7"]])

export default __exports__